export default {
  id: "newzagent",
  appName: "NewzAgent.tv",
  logo: null,

  labels: {
    videos: "Videos",
    myVideos: "My Videos",
    search: "Search videos...",
    content: "videos",
    contentSingular: "video",
    blog: "News & Insights",
  },

  footer: { owner: "NewzAgent.tv", email: null, stripped: false },

  theme: {
    accent: "#ef4444",
    headerTextCls: "text-red-700 dark:text-red-400",
    // NOTE: search ring intentionally falls back to blue to preserve the
    // pre-existing behavior (the old ternary had no newzagent branch).
    searchRingCls: "focus:ring-blue-500",
    quoteIconCls: "text-red-600 dark:text-red-400",
    quoteTextCls: "text-red-400 dark:text-red-300",
    quoteRingCls: "ring-red-500",
    quoteBorderCls: "border-red-500 dark:border-red-400",
    navActiveCls: "bg-red-50 text-red-700 dark:bg-red-900/40 dark:text-red-400",
    navActiveDrawerCls: "bg-red-50 text-red-700 dark:bg-red-900/40 dark:text-red-400 border-r-2 border-red-600",
    chat: {
      accent: "#ef4444",
      accentShadow: "rgba(239, 68, 68, 0.4)",
      tabActiveBg: "#fee2e2",
      tabActiveText: "#dc2626",
      tabActiveBorder: "rgba(239, 68, 68, 0.35)",
    },
  },

  features: {
    blog: false,
    payments: false,
    communityDrip: true,
    shareDrip: true,
    quotePortal: true,
    combatTools: false,
    sportsScorebug: false,
    telegramChat: true,
  },

  communityDripCuratorId: "69a3500cfc89cef8c17e99a6",

  seoDescription: "Political and journalist video intelligence with AI chapters and clips.",

  marketing: {
    features: [
      { emoji: "📑", title: "Auto-Condensed Chapters", desc: "Upload a three-hour hearing or press conference, and AI immediately breaks it down into logical, readable chapters. Jump straight to the topic that matters." },
      { emoji: "💬", title: "Precision Quote Extraction", desc: "No more scrubbing through footage with a notepad. Automatically pull the exact, verbatim quotes required for a brief, an article, or a campaign." },
      { emoji: "✂️", title: "One-Click Highlight Reels", desc: "Select the most critical text segments and instantly generate a concise video clip. Turn hours of debate into a 60-second summary for stakeholders." },
      { emoji: "❝", title: "Top Pull Quotes Portal", desc: "Embed the most important quotes from your entire library on any site. Auto-aggregate or curate the lineup yourself." },
    ],
    personas: [],
    hero: {
      title: "Stop Watching. Start Skimming.",
      sub: "Process huge volumes of news, city council meetings, and press briefings instantly. Upload any video and watch it get magically auto-condensed to your exact specifications.",
      badge: "For Journalists, Politicians, Lobbyists & Municipalities",
    },
    loginVisitor: {
      title: "Stop Watching. Start Knowing.",
      desc: "Turn unmanageable mountains of video content into scannable, searchable, and actionable text intelligence.",
    },
    sections: {
      featuresTitle: "Gain Insight. Skip the Video.",
      featuresSub: "Turn unmanageable mountains of video content into scannable, searchable, and actionable text intelligence.",
      demoTitle: "See NewzAgent in Action",
      personasTitle: "",
      personasSub: "",
      finalCtaTitle: "Ready to stop watching and start knowing?",
      finalCtaSub: "Request a free trial and we'll get you set up right away.",
    },
    blogLabel: "News & Insights",
  },
};
